import module from 'colaborador/module'

export const ColaboradorCajaAhorroConcluirSchema = { aportacionId: 'number' }

export class ColaboradorCajaAhorroConcluirService {
  constructor($http) {
    this.$http = $http
  }

  put(proyectoId, aportacionId) {
    let data = { proyectoId, aportacionId }
    return this.$http.put('/api/colaborador/caja-ahorro/concluir', data, {
      schema: ColaboradorCajaAhorroConcluirSchema,
    })
  }
}

module.service('ColaboradorCajaAhorroConcluir', ColaboradorCajaAhorroConcluirService)



// WEBPACK FOOTER //
// ./src/colaborador/services/Colaborador/CajaAhorro/Concluir.js